var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"environment",class:'environment-' + _vm.env},[_vm._v(" Ambiente: "+_vm._s(_vm.getEnvFullName(_vm.env))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }